export default __webpack_public_path__ + "static/media/Chat Bubbles Question.e6270d5f.svg";